/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import Loader from 'shared/ui/components/Loader.vue';

// Mixins
import copyLink from 'shared/ui/components/listings/custom-actions/copy-link';

const __vue_script__ = {
    name: 'LiveSessionLinks',

    components: {
        DropdownMenu,
        Loader
    },

    mixins: [copyLink],

    props: {
        event: {
            type: Object,
            required: true
        },

        item: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            loading: false,
            remoteLinks: null,
            inPersonLinks: null,
            displaysLinks: null
        };
    },

    methods: {
        async onLinksMenuOpen(open) {
            try {
                if (!open) {
                    this.remoteLinks = null;
                    this.inPersonLinks = null;
                    this.displaysLinks = null;
                }

                if (!open || this.loading) {
                    return;
                }

                this.loading = true;
                const eid = this.event._id;

                const [moderatorLink, speakerLink, mainDisplayLink, liveDisplaysLink] = await Promise.all([
                    this.$services.deepLink.getLiveStreamModeratorLink(eid, this.item),
                    this.$services.deepLink.getLiveStreamSpeakerLink(eid, this.item),
                    this.$services.deepLink.getLiveStreamLiveDisplayLink(eid, this.item),
                    this.$services.liveDisplay.getDocuments(eid, this.item._id)
                ]);

                const remoteLinks = [
                    { label: this.$t('live_sessions.details.moderator_link'), link: moderatorLink },
                    { label: this.$t('live_sessions.details.speaker_link'), link: speakerLink }
                ];

                this.remoteLinks = this.item.session_type === 'IN_PERSON' ? null : remoteLinks;

                const inPersonLinks = [
                    { label: this.$t('live_sessions.details.moderator_link'), link: `${moderatorLink}&inPerson=true` },
                    { label: this.$t('live_sessions.details.speaker_link'), link: `${speakerLink}&inPerson=true` }
                ];

                this.inPersonLinks = this.item.session_type === 'REMOTE' ? null : inPersonLinks;

                const displaysLinks = [];
                if (liveDisplaysLink) {
                    liveDisplaysLink.forEach(function(display) {
                        displaysLinks.push({ label: display.name, link: `${mainDisplayLink}&name=${encodeURIComponent(display.name)}` });
                    });
                }

                this.displaysLinks = displaysLinks.length ? displaysLinks : null;

            } catch (error) {
                console.error('[LiveSessionsList] Could not load links', error.message);
                this.$emit('error', this.$i18n.t('general.try_later'));
            } finally {
                this.loading = false;
            }
        },

        async onOptionSelect(option) {
            this.copyLink(option.link);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-session-links"},[_c('dropdown-menu',{attrs:{"anchor-pos":"ne"},on:{"activator-click":function (isOpen) { return _vm.onLinksMenuOpen(isOpen); }},scopedSlots:_vm._u([{key:"toggler",fn:function(ref){return [_c('button',{staticClass:"btn btn-icon single",attrs:{"type":"button"}},[_c('i',{staticClass:"ic-link"})])]}}])},[(_vm.loading)?_c('loader',{staticClass:"static small",attrs:{"status":true}}):_c('div',{staticClass:"links"},[(_vm.inPersonLinks)?[(_vm.remoteLinks || _vm.displaysLinks)?_c('h5',[_c('i',{staticClass:"ic-in-person"}),_vm._v(_vm._s(_vm.$t('live_sessions.details.attending_in_person')))]):_vm._e(),(_vm.inPersonLinks)?_c('ul',_vm._l((_vm.inPersonLinks),function(option){return _c('li',[_c('button',{staticClass:"btn-list-action",attrs:{"type":"button"},on:{"click":function($event){return _vm.onOptionSelect(option)}}},[_c('i',{staticClass:"ic-copy"}),_vm._v(_vm._s(option.label))])])}),0):_vm._e()]:_vm._e(),(_vm.remoteLinks)?[(_vm.inPersonLinks || _vm.displaysLinks)?_c('h5',[_c('i',{staticClass:"ic-remote"}),_vm._v(_vm._s(_vm.$t('live_sessions.details.attending_remote')))]):_vm._e(),(_vm.remoteLinks)?_c('ul',_vm._l((_vm.remoteLinks),function(option){return _c('li',[_c('button',{staticClass:"btn-list-action",attrs:{"type":"button"},on:{"click":function($event){return _vm.onOptionSelect(option)}}},[_c('i',{staticClass:"ic-copy"}),_vm._v(_vm._s(option.label))])])}),0):_vm._e()]:_vm._e(),(_vm.displaysLinks)?[_c('h5',[_c('i',{staticClass:"ic-monitor"}),_vm._v(_vm._s(_vm.$t('live_sessions.details.attending_live_displays')))]),_c('ul',_vm._l((_vm.displaysLinks),function(option){return _c('li',[_c('button',{staticClass:"btn-list-action",attrs:{"type":"button"},on:{"click":function($event){return _vm.onOptionSelect(option)}}},[_c('i',{staticClass:"ic-copy"}),_vm._v(_vm._s(option.label))])])}),0)]:_vm._e()],2)],1)],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LiveSessionLinks.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__